import { render } from "./AppRow.vue?vue&type=template&id=6d7b3e70&scoped=true&lang=pug"
const script = {}

import "./AppRow.vue?vue&type=style&index=0&id=6d7b3e70&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7b3e70"]])

export default __exports__